/* tslint:disable */
/* eslint-disable */
/**
 * EMLINX API specification
 * This is API specification for EMLINX project.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import { CreateCaseRequest } from '../models';
// @ts-ignore
import { ErrorResponse } from '../models';
/**
 * CreatecaseApi - axios parameter creator
 * @export
 */
export const CreatecaseApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create new case
         * @summary POST Case
         * @param {CreateCaseRequest} [createCaseRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCases: async (createCaseRequest?: CreateCaseRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/cases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCaseRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CreatecaseApi - functional programming interface
 * @export
 */
export const CreatecaseApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CreatecaseApiAxiosParamCreator(configuration)
    return {
        /**
         * Create new case
         * @summary POST Case
         * @param {CreateCaseRequest} [createCaseRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postCases(createCaseRequest?: CreateCaseRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postCases(createCaseRequest, options);
            const index = configuration?.serverIndex ?? 0;
            const operationBasePath = operationServerMap['CreatecaseApi.postCases']?.[index]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, operationBasePath || basePath);
        },
    }
};

/**
 * CreatecaseApi - factory interface
 * @export
 */
export const CreatecaseApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CreatecaseApiFp(configuration)
    return {
        /**
         * Create new case
         * @summary POST Case
         * @param {CreateCaseRequest} [createCaseRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postCases(createCaseRequest?: CreateCaseRequest, options?: any): AxiosPromise<void> {
            return localVarFp.postCases(createCaseRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CreatecaseApi - object-oriented interface
 * @export
 * @class CreatecaseApi
 * @extends {BaseAPI}
 */
export class CreatecaseApi extends BaseAPI {
    /**
     * Create new case
     * @summary POST Case
     * @param {CreateCaseRequest} [createCaseRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CreatecaseApi
     */
    public postCases(createCaseRequest?: CreateCaseRequest, options?: RawAxiosRequestConfig) {
        return CreatecaseApiFp(this.configuration).postCases(createCaseRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

